import { render, staticRenderFns } from "./StateIdList.vue?vue&type=template&id=31ba53f1&scoped=true&"
import script from "./StateIdList.vue?vue&type=script&lang=ts&"
export * from "./StateIdList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ba53f1",
  null
  
)

export default component.exports